var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddOffice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 14C4.69175 14 2 11.3082 2 8C2 4.69175 4.69175 2 8 2C11.3082 2 14 4.69175 14 8C14 11.3082 11.3082 14 8 14M0.5 8C0.5 12.1422 3.85775 15.5 8 15.5C12.1422 15.5 15.5 12.1422 15.5 8C15.5 3.85775 12.1422 0.5 8 0.5C3.85775 0.5 0.5 3.85775 0.5 8Z",
    fill: "#587E85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 8C11 8.414 10.664 8.75 10.25 8.75H8.75V10.25C8.75 10.664 8.414 11 8 11C7.586 11 7.25 10.664 7.25 10.25V8.75H5.75C5.336 8.75 5 8.414 5 8C5 7.586 5.336 7.25 5.75 7.25H7.25V5.75C7.25 5.336 7.586 5 8 5C8.414 5 8.75 5.336 8.75 5.75V7.25H10.25C10.664 7.25 11 7.586 11 8",
    fill: "#587E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddOffice);
export default __webpack_public_path__ + "static/media/add_office.812decad7c2e42efde4b55039426a9d1.svg";
export { ForwardRef as ReactComponent };